import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { PageIncludeMacroRendererProps } from '../src/PageIncludeMacroRenderer.tsx';

export const PageIncludeMacroHandler: LoadableType<PageIncludeMacroRendererProps> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PageIncludeMacro" */ '../src/PageIncludeMacroRenderer.tsx'
			)
		).PageIncludeMacroRenderer,
});
